<template>
    <div class="modal fade" id="myModal" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title"><label>{{ eventDetails.class_name }}</label></h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <!--Class Name-->
                    <div class="row">

                        <!--Class Type-->
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                            <div class="form-group">
                                <label style="font-weight: bold">Class Type</label>
                                <p>{{capitalizeFirstLetter(eventDetails.class_type) }}</p>
                            </div>
                        </div>

                        <!--Recursive Type-->
                        <template v-if="eventDetails.doc_path != null && eventDetails.doc_path != ''">
                            <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label></label>
                                    <a :href="eventDetails.doc_path" target="_blank"><img style="height: 100px; width: 100px" :src="eventDetails.doc_path"/></a>
                                </div>
                            </div>
                        </template>
                    </div>

                    <!--Day of Week-->
                    <template  v-if="eventDetails.class_type === 'recurring' && eventDetails.recurring_type === 'weekly'">
                        <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                            <div class="form-group">
                                <label style="font-weight: bold">Day Of Week</label>
                                <p>{{ eventDetails.week_day }}</p>
                            </div>
                        </div>
                    </template>

                    <!--Normal-->
                    <template v-if="eventDetails.class_type === 'normal'
                                            || (eventDetails.class_type == 'recurring' && eventDetails.recurring_type == 'monthly')
                                            || (eventDetails.class_type == 'recurring' && eventDetails.recurring_type == 'yearly')
                                            ">
                        <!--Date-->
                        <div class="col-12 forms-block d-flex justify-content-between">
                            <div class="col-4">
                                <div class="col-12 paddingleft0">
                                    <div class="form-label" for="startDate" slot="before" style="font-weight: bold">Date :</div>
                                </div>
                                <div class="col-12 paddingleft0">
                                    <p>{{eventDetails.start_date}}</p>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="col-12 paddingleft0">
                                    <div class="form-label" for="startTime" slot="before" style="font-weight: bold">Start Time :</div>
                                </div>
                                <div class="col-12 paddingleft0">
                                    <p>{{eventDetails.start_time}}</p>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="col-12 paddingleft0">
                                    <div class="form-label" for="endTime" slot="before" style="font-weight: bold">End Time :</div>
                                </div>
                                <div class="col-12 paddingleft0">
                                    <p>{{eventDetails.end_time}}</p>
                                </div>
                            </div>
                        </div>
                    </template>
                    <!--End Normal-->

                    <!--Multipledate-->
                    <template v-if="eventDetails.class_type == 'multipledate'">
                        <template v-for="(input, index) in eventDetails.inputs">
                            <div class="col-12 forms-block d-flex justify-content-between">

                                <div class="col-4">
                                    <div class="col-12 paddingleft0">
                                        <div class="form-label" for="endTime" slot="before" style="font-weight: bold">Date</div>
                                    </div>
                                    <div class="col-12 paddingleft0">
                                        <p>{{input.startDate}}</p>
                                    </div>
                                </div>

                                <div class="col-4">
                                    <div class="col-12 paddingleft0">
                                        <div class="form-label" for="endTime" slot="before" style="font-weight: bold">Start Time</div>
                                    </div>
                                    <div class="col-12 paddingleft0">
                                        <p>{{input.startTime.text}}</p>
                                    </div>
                                </div>

                                <div class="col-4">
                                    <div class="col-12 paddingleft0">
                                        <div class="form-label" for="endTime" slot="before" style="font-weight: bold">End Time</div>
                                    </div>
                                    <div class="col-12 paddingleft0">
                                        <p>{{input.endTime.text}}</p>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div class="clearfix"></div>
                    </template>
                    <!--End Multipledate-->

                    <!--Description-->
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="form-group">
                            <label style="font-weight: bold">Description</label>
                            <p v-html="eventDetails.description"></p>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                </div>

                <!--Register-->
                <template v-if="eventDetails.already_register == true && eventDetails.is_register">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="form-group">
                            <button v-on:click="cancelRegistration()" class="form-control btn-danger">Cancel Registration</button>
                            <!--<p style="color: red">You have already register for this class</p>-->
                        </div>
                    </div>
                    <div class="clearfix"></div>
                </template>
                <template v-else-if="eventDetails.is_class_full == true">
                    <p style="color: red">Sorry class is full!</p>
                    <button v-on:click="registerToClass()" class="form-control btn-primary">Register ( {{eventDetails.waiting}} Waiting )</button>
                </template>
                <template v-else-if="eventDetails.attented == true">
                </template>
                <template v-else-if="eventDetails.dependent_class_not_attand == true">
                    <p style="color: red">You are not eligible for this class!</p>
                    <p style="color: red">You need to attand the {{eventDetails.dependent_class_not_attand_string}} classes.</p>
                </template>
                <template v-else>
                    <button v-on:click="registerToClass()" class="form-control btn-primary">Register</button>
                </template>
            </div>
            <!--<div class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            </div>-->
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import {HTTP} from '../../http-common.js';
    import vSelect from 'vue-select';
    import {commonMixins} from '../../mixins/commonMixins';
    import { FullCalendar } from 'vue-full-calendar';
    import 'fullcalendar/dist/fullcalendar.css';
    import EventBus from "./../event-bus";
    import moment from 'moment';

    // ES6 Modules or TypeScript
    import Swal from 'sweetalert2';

    var self;
    var context;
    export default {
        props: ['modelDataId'],
        name: 'calendar',
        components: {
            'v-select': vSelect,
            'full-calendar': FullCalendar
        },
        mixins: [commonMixins],
        data() {
            return {
                eventDetails : [],
                // modelDataId : [],
                loginRoleId : 0,
                startDate: 0,
                endData: 0,
                config: {
                    /*'weekends': false,*/
                    defaultView: 'month',
                    displayEventTime: false,
                    editable: false,
                    eventLimit: true,
                    noEventsMessage: "Classes Not Available",
                    eventClick: (event) => {
                        this.selected = event;
                        this.redirectToUpdate(event);
                    },
                    header: {
                        /*left: 'prev,next',*/
                        left: '',
                        center: 'title',
                        right: 'month,listMonth',
                    },
                    buttonText: {
                        /*'prev': 'Previous',
                         'next': 'Next',*/
                        'month': 'Month',
                        'listMonth': 'List',

                    }
                },
                events: [],
                selected: {},
                eventList: [],
                searchEvents: '',
            }
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            /*self.setActiveMenu('calendarclass');
            EventBus.$emit("menu-selection-changed", "calendarclass");
            self.loginRoleId = self.$store.state.roleId;
            self.startDate = self.$refs.calendar.fireMethod('getView').start.format();
            self.endDate = self.$refs.calendar.fireMethod('getView').end.format();
            self.loadCalendarEvents();*/

        },
        watch: {

        },
        methods: {
            cancelRegistration : function () {
                let userObj = JSON.parse(localStorage.getItem("user_obj"));

                var fields = {
                    class_id: self.modelDataId.row.id,
                    user_id : userObj.id
                };

                var config = {
                    headers: {Authorization:"Bearer " + localStorage.getItem("api_token")},
                };

                HTTP.post('/class/cancelregister', fields, config).
                then(response => {
                    if (response.data.status == "success") {
                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: response.data.message,
                            showConfirmButton: false,
                            timer: 1500
                        });
                        EventBus.$emit("cancelRegistration","");
                        // Swal.fire('', response.data.message, 'success');
                        $('.close').click();
                    }

                })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            //self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //self.$router.push("/login");
                            }
                            //self.error = err.response.data.message;
                        }
                    });
            },
            registerToClass : function() {
                let selectedDate = moment(new Date(self.modelDataId.row.event_date_time)).format("YYYY-MM-DD");
                let userObj = JSON.parse(localStorage.getItem("user_obj"));

                var fields = {
                    class_id: self.modelDataId.row.id,
                    user_id : userObj.id,
                    selected_date : selectedDate
                };

                var config = {
                    headers: {Authorization:"Bearer " + localStorage.getItem("api_token")},
                };

                HTTP.post('/class/register', fields, config).
                then(response => {
                    if (response.data.status == "success") {
                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: response.data.message,
                            showConfirmButton: false,
                            timer: 1500
                        });
                        this.$emit('callListAgain')
                        // Swal.fire('', response.data.message, 'success');
                        $('.close').click();
                    }

                })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            //self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //self.$router.push("/login");
                            }
                            //self.error = err.response.data.message;
                        }
                    });
            },
            getClassDetailsById: function () {
                let userObj = JSON.parse(localStorage.getItem("user_obj"));
                let selectedDate = moment(new Date(self.modelDataId.row.event_date_time)).format("YYYY-MM-DD");

                var fields = {
                    class_id: self.modelDataId.row.id,
                    user_id : userObj.id,
                    selected_date : selectedDate
                };

                var config = {
                    headers: {Authorization:"Bearer " + localStorage.getItem("api_token")},
                };

                HTTP.post('/class/getmodeldata', fields, config).
                then(response => {
                    if (response.status == 200) {
                        $('#openModel').click();
                        self.eventDetails = response.data.content;

                        switch (self.eventDetails.week_day) {
                            case "1" :
                                self.eventDetails.week_day = "Monday";
                                break;
                            case "2" :
                                self.eventDetails.week_day = "Tuesday";
                                break;
                            case "3" :
                                self.eventDetails.week_day = "Wednesday";
                                break;
                            case "4" :
                                self.eventDetails.week_day = "Thursday";
                                break;
                            case "5" :
                                self.eventDetails.week_day = "Friday";
                                break;
                            case "6" :
                                self.eventDetails.week_day = "Saturday";
                                break;
                            case "7" :
                                self.eventDetails.week_day = "Sunday";
                                break;
                        }
                    }
                })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            //self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //self.$router.push("/login");
                            }
                            //self.error = err.response.data.message;
                        }
                    });
            },
        }
    }
    EventBus.$on('CLASS_COMMON_PAGE', (payload) => {
        if (typeof  self != "undefined") {
            self.$nextTick(function () {
                self.getClassDetailsById();
                $('#myModal').modal('toggle');
            });
        }

    })
</script>




// WEBPACK FOOTER //
// src/components/CommonModelForClass/CommonModel.vue